import React from "react";
import DarsVideoPlayer from "./DarsVideoPlayer";

const VideoS = "/Video/html.mp4";

function Video(props) {
  return (
    <div style={{ width: "450px" }}>
      <DarsVideoPlayer src={VideoS} />
    </div>
  );
}

export default Video;
